module.exports = {"Operate16":{"daobanList":[{"title":"1:不定时工作制、综合计算工时工作制","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、企业实行不定时或综合计算工时工作制申请表","state":"必要"},{"name":"2、企业实行不定时工作制和综合计算工时工作制审批材料","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-16.json
// module id = 1273
// module chunks = 0